module.exports = {
	"id": "KM",
	"name": "Comoros",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.009018,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.049599,
			"10": 0.027054,
			"11": 0.085671,
			"12": 0.022545,
			"13": 0.18036,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.04509,
			"19": 0.009018,
			"20": 0.004509,
			"21": null,
			"22": 0.018036,
			"23": 0.036072,
			"24": null,
			"25": 0.022545,
			"26": 0.009018,
			"27": 0.009018,
			"28": 0.022545,
			"29": 0.018036,
			"30": 0.004509,
			"31": 0.009018,
			"32": 0.031563,
			"33": 0.031563,
			"34": 0.009018,
			"35": 0.018036,
			"36": 0.004509,
			"37": null,
			"38": null,
			"39": 0.036072,
			"40": 0.085671,
			"41": 2.457405,
			"42": 0.004509,
			"43": 0.464427,
			"44": 0.004509,
			"45": 0.202905,
			"46": 0.004509,
			"47": 0.085671,
			"48": 0.036072,
			"49": 1.12725,
			"50": 0.040581,
			"51": 1.064124,
			"52": 0.608715,
			"53": 14.451345,
			"54": 3.250989,
			"55": 0.013527,
			"56": 0.09018,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.081162,
			"4": 0.018036,
			"5": null,
			"6": null,
			"7": 0.009018,
			"8": null,
			"9": null,
			"10": 0.734967,
			"11": 0.022545,
			"12": 0.072144,
			"13": null,
			"14": 0.018036,
			"15": null,
			"16": 0.004509,
			"17": 0.004509,
			"18": 0.009018,
			"19": 0.009018,
			"20": 0.009018,
			"21": 0.018036,
			"22": 0.004509,
			"23": null,
			"24": 0.018036,
			"25": 0.004509,
			"26": 0.004509,
			"27": null,
			"28": null,
			"29": 0.049599,
			"30": 0.058617,
			"31": 0.762021,
			"32": 0.018036,
			"33": 0.18036,
			"34": 0.004509,
			"35": 0.036072,
			"36": 0.103707,
			"37": 0.022545,
			"38": 0.297594,
			"39": 0.04509,
			"40": 0.049599,
			"41": 0.009018,
			"42": 0.036072,
			"43": 0.685368,
			"44": 0.076653,
			"45": 0.085671,
			"46": 0.117234,
			"47": 0.72144,
			"48": 1.028052,
			"49": 8.88273,
			"50": 0.076653,
			"51": 0.036072,
			"52": null,
			"3.5": null,
			"3.6": 0.004509
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": 0.036072,
			"16": null,
			"17": null,
			"18": 0.117234,
			"19": null,
			"20": 0.004509,
			"21": 0.004509,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.009018,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.36072,
			"37": 0.022545,
			"38": 0.04509,
			"39": 0.009018,
			"40": 0.613224,
			"41": 0.148797,
			"42": 0.004509,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.004509
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": 0.099198,
			"7": 0.004509,
			"8": null,
			"9": 0.09018,
			"10": 0.081162,
			"3.1": null,
			"3.2": null,
			"5.1": 0.112725,
			"6.1": 0.009018,
			"7.1": null,
			"9.1": 0.031563
		},
		"ios_saf": {
			"8": 0,
			"10": 1.10376853289,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0297452847627,
			"8.1-8.4": 0.0549531532057,
			"9.0-9.2": 0.0262161831807,
			"9.3": 0.399964845962
		},
		"android": {
			"3": 0,
			"4": 0.149603782946,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0187004728682,
			"4.1": 0.539642217054,
			"4.2-4.3": 1.34910554264,
			"4.4": 3.09359251163,
			"4.4.3-4.4.4": 3.12030747287
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.181337560976,
			"9": 0.0544012682927,
			"10": 0.122402853659,
			"11": 1.31469731707,
			"5.5": null
		},
		"op_mob": {
			"0": 1.55776933228,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0432713703411
		},
		"edge": {
			"12": 0.234468,
			"13": 0.175851,
			"14": 0.09018
		},
		"ie_mob": {
			"10": 0.108292957746,
			"11": 0.440907042254
		},
		"bb": {
			"7": 0.012357,
			"10": null
		},
		"samsung": {
			"0": 0.60412
		},
		"and_uc": {
			"0": 1.850804
		},
		"op_mini": {
			"0": 20.9875552974
		},
		"and_chr": {
			"0": 20.330552
		},
		"and_ff": {
			"0": 0.010984
		}
	},
	"total": 98.947271
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/KM.json
 ** module id = 564
 ** module chunks = 0
 **/